import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

interface PopularSuggestion {
  text: string;
  icon: string;
  category: string;
  popularity: number;
}

const categoryIcons: Record<string, string> = {
  'tech': '💻',
  'finance': '💰',
  'business': '🏦',
  'mentorat': '🎯',
  'design': '🎨',
  'conseil': '💡',
  'marketing': '📢',
  'ia': '🤖',
  'général': '🔍'
};

const getDefaultSuggestions = (): PopularSuggestion[] => [
  { text: 'développeurs', icon: '💻', category: 'Tech', popularity: 50 },
  { text: 'experts', icon: '🤖', category: 'Tech', popularity: 45 },
  { text: 'investisseurs', icon: '💰', category: 'Finance', popularity: 40 },
  { text: 'mentors', icon: '🎯', category: 'Mentorat', popularity: 35 },
];

export const usePopularSearchSuggestions = (limit: number = 8) => {
  const [suggestions, setSuggestions] = useState<PopularSuggestion[]>(getDefaultSuggestions());
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchPopularSuggestions = async () => {
      try {
        setIsLoading(true);
        
        const { data, error } = await supabase
          .rpc('get_search_suggestions', {
            prefix_text: '',
            limit_count: limit
          });

        if (error) throw error;

        if (data && data.length > 0) {
          const mappedSuggestions: PopularSuggestion[] = data.map((item) => {
            const categoryLower = (item.category || 'général').toLowerCase();
            return {
              text: item.suggestion,
              icon: categoryIcons[categoryLower] || categoryIcons['général'],
              category: item.category || 'Général',
              popularity: item.popularity
            };
          });
          
          setSuggestions(mappedSuggestions);
        }
      } catch (error) {
        console.error('Erreur chargement suggestions populaires:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchPopularSuggestions();
  }, [limit]);

  return { suggestions, isLoading };
};
